import React from "react";
import { useMediaQuery } from "react-responsive";
import SelectBids from "../children/SelectBids";
import SelectContract from "../children/SelectContract";


function SelectAuctionTypeAndCordinator({
    setAuctionDetails,
    auctionDetails,
}) {
    const isTablet = useMediaQuery({ query: "(max-width: 600px)" });

    return (
        <div className="flex column gap-1">
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: !isTablet && "1fr 1fr 1fr",
                    gap: "20px",
                }}
            >
                <span className="flex column mr-2">
                    <label className="font-16px black-text">Coordinator <span className="red-text">*</span></label>
                    <input
                        placeholder={"Old Coordinator selected  (Disable)"}
                        className={`input-tag-style`}
                        disabled={true}
                    />
                </span>
                <SelectBids
                    auctionDetails={auctionDetails}
                    setAuctionDetails={setAuctionDetails}
                />
                <SelectContract
                    auctionDetails={auctionDetails}
                    setCreateOffer={setAuctionDetails}
                />
            </div>
        </div>
    );
}

export default SelectAuctionTypeAndCordinator;